import { render, staticRenderFns } from "./ConfirmCover.vue?vue&type=template&id=28ae850b&"
import script from "./ConfirmCover.vue?vue&type=script&lang=js&"
export * from "./ConfirmCover.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports